import { render } from "preact";
import Root from "./Root";
import type { PageConfig } from "./types";
import "preact/debug";

const root = document.getElementById("app");
const config: PageConfig = window.__MEETDAY__ ?? { page: "welcome" };
if (root) {
  render(<Root config={config} />, root);
}
